import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import React from "react";


function C4FInfoButton(props) {

  return (
    <OverlayTrigger trigger="click" placement={props.placement} overlay={
      <Popover id="popover-basic">
        <Popover.Header as="h3">{props.title}</Popover.Header>
        <Popover.Body>{props.text}</Popover.Body>
      </Popover>}>
      <Button size={'size' in props ? props.size : null} variant="outline-secondary">{'\u24D8'}</Button>
    </OverlayTrigger>
  );
}

export default C4FInfoButton;
